import heic2any from 'heic2any'

const dimensionsValidation = ((constraint, value) => {
  const { minimumValue, maximumValue } = constraint.parameters
  if (value < minimumValue || value > maximumValue) {
    return constraint.messageKey
  }
  return null
})

export const ratioValidation = (constraint, width, height) => {
  const calcRatio = c => {
    const values = c.split(':')
    return parseFloat((values[0] / values[1]).toFixed(2))
  }

  const { minimumValue, maximumValue } = constraint.parameters
  const ratio = parseFloat((width / height).toFixed(2))

  if ( (minimumValue && ratio < calcRatio(minimumValue)) || (maximumValue && ratio > calcRatio(maximumValue))) {
    return constraint.messageKey
  }

  return null
}

export const replaceMessageKeys = (errors, uiSchema) => errors.map(err => uiSchema['ui:errorMessages'][err])

export const validateItem = (item, validations) => {
  const constraints = validations.reduce((acc, validation) => ({
    ...acc,
    [validation.validationType]: validation
  }), {})

  const errors = []
  constraints.ImageHeightRange && errors.push(dimensionsValidation(constraints.ImageHeightRange, item.Height || 0))
  constraints.ImageWidthRange && errors.push(dimensionsValidation(constraints.ImageWidthRange, item.Width || 0))
  constraints.ImageRatio && errors.push(ratioValidation(constraints.ImageRatio, item.Width || 0, item.Height || 0))
  return errors.filter(error => !!error)
}


export const validateImage = async (imageData, size, validations) => {
  return new Promise((resolve) => {
    const img = new Image()
    img.onload = () => {
      const { naturalWidth: width, naturalHeight: height } = img
      const constraints = validations.reduce((acc, validation) => ({
        ...acc,
        [validation.validationType]: validation
      }), {})

      const errors = []
      constraints.ImageHeightRange && errors.push(dimensionsValidation(constraints.ImageHeightRange, height))
      constraints.ImageWidthRange && errors.push(dimensionsValidation(constraints.ImageWidthRange, width))
      constraints.ImageMaxSize && constraints.ImageMaxSize.parameters.maxSizeMB * 1024* 1024 < size && errors.push(constraints.ImageMaxSize.messageKey)
      constraints.ImageRatio && errors.push(ratioValidation(constraints.ImageRatio, width, height))
      resolve(errors.filter(error => !!error))
    }
    img.src = imageData
  })
}

export const assetAllowedToBeCropped = (fileName) => {
  const re = /\.(pdf|tiff|tif)$/i
  return !re.test(fileName)
}

export const isTiff = (fileName) => {
  const re = /\.(tiff|tif)$/i
  return re.test(fileName)
}

export const uploadAsset = async (propertyId, file, imageData, validation, replaceIfExists) => {
  const canBeCropped = assetAllowedToBeCropped(file.name)
  const fileIsTiff = isTiff(file.name)

  let errors = []
  if (canBeCropped && !fileIsTiff) {
    errors = await validateImage(imageData, file.size, validation)
  }

  const maxSize = validation.find(v => v.validationType === 'ImageMaxSize')
  if (maxSize) {
    if (errors.find(e => e === maxSize.messageKey)) {
      return {canBeCropped, item: null, errors}
    }
  }

  const item = await window.UStoreProvider.state.assets.uploadAsset(propertyId, file, replaceIfExists)
  if (fileIsTiff) {
    errors = validateItem(item, validation)
  }

  return {canBeCropped, item, errors}
}

export const compressImage = async ({ file, maxSizeMB = 5, qualityStep = 0.1, currentQuality = 0.9 }) => {
  if (currentQuality < 0.1) {
    throw new Error('Cannot reach desired file size');
  }
  const KB = 1024

  try {
    const convertedBlob = await heic2any({
      blob: file,
      toType: "image/jpeg",
      quality: currentQuality
    });

    if (convertedBlob.size <= maxSizeMB * KB * KB) {
      return convertedBlob;
    } else {
      return await compressImage({ file, maxSizeMB, qualityStep, currentQuality: currentQuality -qualityStep });
    }
  } catch (error) {
    console.error('Error during conversion: ', error);
    throw new Error('Error while converting image');
  }
}
